import { FilterType } from 'portal-commons';
import { getDateRangePresets } from '@/constants/time';
import {
  getCspCompanyNameAutocompleteOptions,
  getCspNameAutocompleteOptions,
} from '@/apis/services';

export const FILTER_CONFIG = {
  campaignUid: {
    type: FilterType.Text,
    label: 'Campaign ID',
    placeholder: 'Type Campaign ID',
  },
  companyName: {
    type: FilterType.Text,
    label: 'CSP Legal Name',
    placeholder: 'Type CSP Legal Name',
    suggestions: [],
  },
  displayName: {
    type: FilterType.Text,
    label: 'CSP DBA Name',
    placeholder: 'Type CSP DBA Name',
    suggestions: [],
  },
  nnid: {
    type: FilterType.Text,
    label: 'NNID',
    placeholder: 'Type NNID',
  },
  current: {
    width: 285,
    type: FilterType.Dropdown,
    label: 'Campaign Currently Associated',
    placeholder: 'Select Currently Associated',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  },
  dateRange: {
    width: 265,
    type: FilterType.DateRange,
    label: 'Campaign Associated Range',
    placeholder: 'Select date range',
    delayUpdate: false,
    dateRangePresets: getDateRangePresets(),
  },
};

export const FILTER_LOADERS = {
  suggestion: {
    companyName: {
      minLength: 2,
      load: (value: string) => getCspCompanyNameAutocompleteOptions(value),
    },
    displayName: {
      minLength: 2,
      load: (value: string) => getCspNameAutocompleteOptions(value),
    },
  },
};

export const TABLE_COLUMNS = [
  { id: 'campaignUid', label: 'CAMPAIGN ID', sortable: false },
  { id: 'cspLegalName', label: 'CSP LEGAL NAME', sortable: false },
  { id: 'cspDbaName', label: 'CSP DBA NAME', sortable: false },
  { id: 'nnid', label: 'NNID', sortable: false },
  { id: 'current', label: 'CAMPAIGN CURRENTLY ASSOCIATED', sortable: false },
  { id: 'startTimestamp', label: 'PROVISIONED ON', sortable: true },
  { id: 'endTimestamp', label: 'DEPROVISIONED ON', sortable: false },
];

export const PAGE_SIZE = 10;
